<template>
	<v-switch
		v-if="type === attributeType.boolean"
		v-model="localValue"
		v-bind="bindProps"
		:ripple="false"
		:label="localValue ? 'Yes' : 'No'"
		@change="$emit('change')"
	/>
	<v-text-field
		v-else-if="type === attributeType.number"
		v-model.number="localValue"
		type="number"
		hide-spin-buttons
		v-bind="bindProps"
		@change="$emit('change')"
	/>
	<v-text-field
		v-else-if="type === attributeType.string"
		v-model="localValue"
		v-bind="bindProps"
		@change="$emit('change')"
	/>
	<v-chip-group
		v-else-if="!useAutocomplete && [
			attributeType.multiChoice,
			attributeType.multiOptions,
			attributeType.yesNoMultiChoice,
		].includes(type) && items.length"
		v-model="localValue"
		v-bind="bindProps"
		color="primary"
		column
		:multiple="type === attributeType.multiOptions"
		@input="$emit('change')"
	>
		<v-chip
			v-for="(item, i) in items"
			:key="i"
			:value="item"
			class="d-flex justify-center align-center text-center"
			:class="
				typeof item === 'string'
					? [item.length <= 14 ? 'text-h6' : 'text-body-1 font-weight-semi-bold']
					: 'text-h6'
			"
			:style="{ width: '120px', height: '120px', whiteSpace: 'normal' }"
		>
			{{item}}
		</v-chip>
	</v-chip-group>
	<v-autocomplete
		v-else-if="useAutocomplete && [
			attributeType.multiChoice,
			attributeType.multiOptions,
			attributeType.yesNoMultiChoice,
		].includes(type)"
		v-model="localValue"
		v-bind="bindProps"
		:items="items"
		:multiple="type === attributeType.multiOptions"
		@input="$emit('change')"
	/>
	<v-chip-group
		v-else-if="[attributeType.color, attributeType.multipleColor].includes(type)"
		v-model="localValue"
		v-bind="bindProps"
		color="primary"
		:multiple="type === attributeType.multipleColor"
		column
		@change="$emit('change')"
	>
		<v-chip
			v-for="(item, i) in items"
			:key="i"
			:value="item"
			active-class="primary"
			outlined
			class="d-flex justify-center align-center rounded-circle pa-0"
			:class="{
				'red':
					error || (rules && rules.map(rule => Boolean(rule(localValue))).filter(c => !c).length)
			}"
			:style="{
				width: !dense ? '60px' : '30px',
				height: !dense ? '60px' : '30px'
			}"
		>
			<v-icon :color="item" :size="!dense ? 59 : 29">mdi-circle</v-icon>
		</v-chip>
	</v-chip-group>
	
	<!-- <v-autocomplete
		v-else-if="[
			attributeType.multiChoice,
			attributeType.multiOptions,
			attributeType.yesNoMultiChoice,
		].includes(type)"
		v-model="localValue"
		v-bind="bindProps"
		:multiple="type === attributeType.multiOptions"
	/> -->
	<!-- <v-menu
		v-else-if="type === attributeType.color"
		ref="menu"
		offset-y
		:close-on-content-click="false"
		max-width="300"
	>
		<template v-slot:activator="{ on, attr }">
			<v-text-field
				readonly
				:value="localValue"
				v-bind="{ ...bindProps, ...attr }"
				v-on="on"
			>
				<template v-slot:prepend-inner>
					<v-icon :color="localValue">mdi-circle</v-icon>
				</template>
			</v-text-field>
		</template>
		<v-card class="pa-1">
			<v-color-picker
				v-model="localValue"
				mode="hexa"
				v-bind="bindProps"
			/>
			<v-card-actions class="pt-0 justify-end">
				<v-btn
					small
					color="primary"
					class="rounded-lg"
					@click="$refs.menu.save(localValue)"
				>
					{{$t('close')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-menu> -->
</template>

<script>
import { attributeType } from '@/helpers/enums'
export default {
	name: 'BeeAttributeInput',
	
	/* eslint-disable vue/require-default-prop */
	props: {
		type: { type: Number, default: attributeType.string },
		label: { type: String },
		placeholder: { type: String },
		dense: { type: Boolean },
		readonly: { type: Boolean },
		outlined: { type: Boolean },
		multipleInputsBind: { type: [Object, Function] },
		hideDetails: { type: [Boolean, String] },
		useAutocomplete: { type: Boolean },
		error: { type: Boolean },
		rules: { type: Array },
		inputProps: { type: Object, default: () => ({}) },
		items: { type: Array, default: () => [] },
		value: { type: [String, Number, Boolean, Array] }
	},

	data: () => ({
		attributeType,

		inputArray: [
			null
		],
	}),

	watch: {
		value: {
			handler(val) {
				if (
					[
						attributeType.multiChoice,
						attributeType.multiOptions,
						attributeType.yesNoMultiChoice
					].includes(this.type) &&
					Array.isArray(val)
				) {
					this.inputArray = [...val, null];
				}
			},
			immediate: true,
		}
	},

	/* eslint-disable vue/order-in-components */
	computed: {
		bindProps() {
			return {
				...this.inputProps,
				label: this.label,
				placeholder: this.placeholder,
				dense: this.dense,
				readonly: this.readonly,
				outlined: this.outlined,
				'hide-details': this.hideDetails,
				error: this.error,
				rules: this.rules,
				class: 'rounded-medium',
			}
		},

		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
				/* if (
					[
						attributeType.multiChoice,
						attributeType.multiOptions,
						attributeType.yesNoMultiChoice
					].includes(this.type)
				) {
					this.$emit('input', this.inputArray);
				} else {
					this.$emit('input', val);
				} */
			}
		}
	}
}
</script>

<style>

</style>